import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { type FC, useMemo } from 'react';

import { TeamData } from '../data';

const Team: FC = () => {
  const randomizedMembers = useMemo(() => {
    return [...TeamData.members].sort(() => Math.random() - 0.5);
  }, []);

  return (
    <Box
      id="team"
      sx={{
        pb: 8,
      }}
    >
      <Box
        sx={{
          display: 'grid',
        }}
      >
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Roboto',
            fontWeight: 800,
            fontSize: '45px',
            lineHeight: '50px',
            textAlign: 'center',
            py: 3,
          }}
        >
          Nuestro Equipo
        </Typography>
        <Divider
          sx={{
            width: '80px',
            margin: '0 auto',
            borderColor: '#47BCD8',
            borderWidth: 2,
            mb: 4,
          }}
        />
        <Box
          sx={{
            px: { xs: 2, sm: 4, md: 6 },
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            {randomizedMembers.map((member) => (
              <Grid size={{ xs: 12, sm: 6, md: 2.4 }} key={member.name}>
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    backgroundColor: 'white',
                    borderRadius: 5,
                    transition: 'transform 0.2s ease-in-out',
                  }}
                >
                  <Box
                    component="img"
                    src={member.img}
                    alt={member.name}
                    sx={{
                      width: '150px',
                      height: '150px',
                      borderRadius: '50%',
                      mb: 2,
                    }}
                  />
                  <Typography
                    variant="h6"
                    sx={{
                      fontFamily: 'Roboto',
                      fontWeight: 700,
                      fontSize: '16px',
                      textAlign: 'center',
                    }}
                  >
                    {member.name}
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{
                      fontFamily: 'Roboto',
                      fontSize: '14px',
                      color: '#2C5889',
                      textAlign: 'center',
                      mb: 1,
                    }}
                  >
                    {member.job}
                  </Typography>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 0.5,
                      mb: 1,
                    }}
                  >
                    {member.icons.map((icon) => (
                      <Box
                        key={`${member.name}-${icon}`}
                        component="img"
                        src={icon}
                        alt={`${member.name} icon`}
                        sx={{
                          width: '25px',
                          height: '25px',
                          objectFit: 'contain',
                        }}
                      />
                    ))}
                  </Box>
                  <Box>
                    {member.prevJob.map((job) => (
                      <Typography
                        key={`${member.name}-${job.place}-${job.title}`}
                        variant="body2"
                        sx={{
                          fontFamily: 'Roboto',
                          fontSize: '12px',
                          color: '#666',
                          textAlign: 'center',
                        }}
                      >
                        {job.title} - {job.place}
                      </Typography>
                    ))}
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};

export default Team;
